export const GOOGLE_PLAY_STORE_URL = 'https://alawwalpark.page.link/mobile';
export const APP_STORE_URL = 'https://alawwalpark.page.link/mobile';
export const HUAWEI_STORE_URL = 'https://appgallery.huawei.com/app/C108982577';
